/**
 * Catálogo dos eventos de uso (decisões 97 e 164 a 172; `docs/telemetria.md` do backend).
 *
 * `activityCatalog.json` é cópia do `src/app/v2/lib/activityCatalog.json` do backend: o servidor
 * recusa (e guarda em `activity_rejected`) o que não bater com a cópia dele. Mudou lá, copia aqui.
 * O painel usa daqui a versão de cada evento, quem pode emitir e a prioridade no pool.
 */
import catalog from './activityCatalog.json';

export type ActivityEventName = keyof typeof catalog.events;
export type ActivitySurface = 'panel' | 'extension';
/** 1 sai do pool por último; 3 sai primeiro quando o pool passa do teto. */
export type ActivityPriority = 1 | 2 | 3;

export interface ActivitySpec {
  v: number;
  from: readonly string[];
  priority: ActivityPriority;
}

export const ACTIVITY_CATALOG_VERSION: number = catalog.version;

const EVENTS = catalog.events as unknown as Record<string, ActivitySpec>;

export function activitySpec(name: string): ActivitySpec | null {
  return Object.prototype.hasOwnProperty.call(EVENTS, name) ? (EVENTS[name] ?? null) : null;
}

/** O evento existe e pode sair desta superfície (o painel nunca se passa pela extensão). */
export function canEmit(name: string, surface: ActivitySurface): boolean {
  const spec = activitySpec(name);
  return Boolean(spec && spec.from.includes(surface));
}
